// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__2cgmz","red":"Section_red__15VRa","blue":"Section_blue__1pEEK","green":"Section_green__1aCGZ"};